import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://00c992774c130cb71f4a44e8d1bfe092@o4509074739494912.ingest.us.sentry.io/4509074749587456",

  // This enables automatic instrumentation
  integrations: [
    Sentry.browserTracingIntegration(),
  ],

  // Set sampling rate to 100% during testing
  tracesSampleRate: 1.0,

  // Control which URLs should have trace headers included
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  
  // Add environment to distinguish between dev/prod
  environment: process.env.NODE_ENV,
  
  // Debug mode during development
  debug: process.env.NODE_ENV !== 'production',
});

export default Sentry;